import React from 'react';

export default ({user, inviteUser})  => {
    return (
        <div
          onClick={() => inviteUser(user)}
          className="potential-user">
          {user}
        </div>
    );
};
